import styled, { css } from "styled-components";

import { ExternalAnchor } from "..";

export const FooterContainer = styled.div`
  background: linear-gradient(
    360deg,
    #f0f0fc 0%,
    #fcfcff 60.33%,
    #ffffff 94.94%
  );
`;

export const StyledFooter = styled.footer<{ $isDark?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 0 64px;
  gap: 8px;
  margin: 0 auto;
  ${({ $isDark }) =>
    $isDark
      ? css`
          color: ${({ theme }) => theme.colors.white};
        `
      : css`
          color: ${({ theme }) => theme.colors.graySolid6};
        `};

  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    gap: 12px;
    padding-bottom: 32px;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;

  & > img {
    height: 22px;
    width: auto;
    object-fit: contain;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    align-items: center;

    & > img {
      height: 18px;
    }
    p {
      text-align: center;
      font-size: 12px;
    }
  }
`;

export const SocialLinksContainer = styled.div<{ $isDark?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;

  ${({ $isDark }) =>
    $isDark
      ? css`
          color: ${({ theme }) => theme.colors.white};
        `
      : css`
          color: ${({ theme }) => theme.colors.blue30};
        `};
  a {
    color: currentColor;
  }
  &:hover {
    a {
      color: currentColor;
    }
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    & > a > span {
      height: 16px;
      & > span {
        width: 16px;
        height: 16px;
        mask-size: 16px;
      }
    }
  }
`;

export const AppStatusWrapper = styled(ExternalAnchor)<{ $color: string }>`
  color: ${({ $color }) => $color};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
  opacity: 1;
  align-self: flex-start;

  &:hover {
    color: ${({ $color }) => $color};
  }

  &:before {
    content: "";
    width: 16px;
    height: 16px;
    background-color: ${({ $color }) => $color};
    border-radius: 50%;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    justify-content: center;
    order: 2;
    margin-bottom: 0;
    align-self: normal;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

export const HideOnMobile = styled.div`
  padding: 8px 0;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ShowOnMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 12px;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
  }
`;
